import React from 'react';
import ListProperties from '@/scripts/ListProperties';
import ListScript from './ListScript';
import ListReportsCache from './ListReportsCache';
import ListCompactReportsCache from './ListCompactReportsCache';
import Dimmer from '+/Dimmer';
import { useState } from 'react';
import { useGetScript } from '~/scripts';
import MuiMarkdown from 'mui-markdown';


const Comp = props => {

    const {
        isLoading, isError, data, isFetching
    } = useGetScript();


    const [tab, setTab] = useState(props.match?.params?.page);


    if (isLoading || isFetching) {
        return <Dimmer />;
    }

    if (isError) {
        return 'Internal Error - Contact Technical Support';
    }

    //Select the first one if you land on the main page
    if (!tab) {
        setTab(Object.keys(data)[0]);
    }

    let show_properties = tab;
    let show_reports_cache = false;

    if (show_properties === 'cache-config'){
        show_properties = false;
        show_reports_cache = true;
    }

    return (
        <div>
            <div>
                <ListScript runScript={true} tab={tab} data={data} setTab={setTab}></ListScript>
                <br/>
                <br/>
                <br/>
                {/* <content>
                    <div dangerouslySetInnerHTML={{ __html: data[tab] }}/>
                </content> */}
                <MuiMarkdown
                    overrides={{
                        h4: {
                            component: 'h4',
                            props: {
                                style: {
                                    color: '#002144',
                                    fontSize: '2rem',
                                    lineHeight: '40px'
                                }
                            }
                        },
                        h6: {
                            props: {
                                component: 'h6',
                                style: {
                                    color: '#002144',
                                    fontSize: '1.10rem',
                                    lineHeight: '40px'
                                }
                            }
                        }
                    }} >
                    {data[tab]}
                </MuiMarkdown>
                { (show_properties)
                    ? (<ListProperties tab={tab}></ListProperties>)
                    : (<></>)
                }
                { (show_reports_cache)
                    ? (<ListCompactReportsCache />)
                    : (<></>)
                }

                { (show_reports_cache)
                    ? (
                        <div>
                            <br/>
                            <br/>
                            <h2 style={{
                                color: '#002144',
                                fontSize: '2rem',
                                lineHeight: '40px'
                            }}>Detailed</h2>
                            <br/>
                            <ListReportsCache />
                        </div>)
                    : (<></>)
                }
            </div>
        </div>

    );
};


export default Comp;
